<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button icon="arrow-back-outline" [text]="'CATCHMENT' | translate" (click)="closeStation()"></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="resetToIslandsView()"><ion-icon name="home"></ion-icon></ion-button>
            <ion-button appShareUrl="station">
                <ion-icon name="share-outline" slot="icon-only"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content appSuppressScrollEvent class="station ion-padding">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title class="--h1" [innerHTML]="(station$ | async)?.id + ' - ' + (station$ | async)?.name"></ion-title>
        </ion-toolbar>
    </ion-header>

    <div class="station__content">
        @if ((station$ | async)?.type === "1") {
            <p
                class="station__content__name --p1"
                [innerHTML]="
                    (station$ | async)?.lastReadWL
                        ? ('LAST_UPDATE'
                          | translate: { date: (station$ | async)?.lastReadWL | date: 'dd/MM/YY HH:mm' : translateService.defaultLang })
                        : (station$ | async)?.lastReadWL
                "
            ></p>
        }

        @if ((station$ | async)?.type === "0") {
            <p
                class="station__content__name --p1"
                [innerHTML]="
                    (station$ | async)?.lastReadR60
                        ? ('LAST_UPDATE'
                          | translate: { date: (station$ | async)?.lastReadR60 | date: 'dd/MM/YY HH:mm' : translateService.defaultLang })
                        : (station$ | async)?.lastReadR60
                "
            ></p>
        }

        @if ((station$ | async)?.type === "2") {
            <p
                class="station__content__name --p1"
                [innerHTML]="
                    (station$ | async)?.lastReadR60
                        ? ('LAST_UPDATE_METEO'
                          | translate: { date: (station$ | async)?.lastReadR60 | date: 'dd/MM/YY HH:mm' : translateService.defaultLang })
                        : (station$ | async)?.lastReadR60
                "
            ></p>
            <p
                class="station__content__name --p1"
                [innerHTML]="
                    (station$ | async)?.lastReadWL
                        ? ('LAST_UPDATE_HIDRO'
                          | translate: { date: (station$ | async)?.lastReadWL | date: 'dd/MM/YY HH:mm' : translateService.defaultLang })
                        : (station$ | async)?.lastReadWL
                "
            ></p>
        }

        @if ((station$ | async)?.type === "1" || (station$ | async)?.type === "2") {
            <div class="title-with-info">
                <p class="station__content__title --h2" [innerHTML]="'HYDROMETRIC_DATA' | translate"></p>
                <ion-button class="info-button" fill="clear" id="popover-trigger-hydro-station">
                    <ion-icon name="information-circle-outline"></ion-icon>
                </ion-button>
                <ion-popover trigger="popover-trigger-hydro-station" triggerAction="click">
                    <ng-template>
                        <ion-content class="ion-padding modal-info">
                            {{ "HYDRO_DATA_BUTTON_INFO" | translate }}
                        </ion-content>
                    </ng-template>
                </ion-popover>
            </div>

            <!-- Hack to allow for straight top borders without touching the app-chart component -->
            <div [class.empty-chart-placeholder]="emptyHidroData$ | async">
                @if (!(emptyHidroData$ | async)) {
                    <app-manager-chart>
                        @if (hasWaterLevelData$ | async) {
                            <app-chart-tab [title]="'WATER_LEVEL' | translate">
                                <app-water-level-chart
                                    [alertLevels]="(stationData$ | async)?.alertLevels"
                                    [data]="(stationData$ | async)?.waterLevel"
                                    [simulationData]="stationSimulationWaterLevelData$ | async"
                                ></app-water-level-chart>
                            </app-chart-tab>
                        }
                        @if (hasDischargeData$ | async) {
                            <app-chart-tab [title]="'DISCHARGE' | translate">
                                <app-discharge-chart
                                    [alertLevels]="(stationData$ | async)?.alertLevels"
                                    [observedData]="(stationData$ | async)?.discharge"
                                    [simulationData]="stationSimulationDischargeData$ | async"
                                ></app-discharge-chart>
                            </app-chart-tab>
                        }
                    </app-manager-chart>
                } @else {
                    <app-empty-data [display]="true" [text]="'SENSOR_NO_DATA' | translate"></app-empty-data>
                }
            </div>
        }

        @if ((station$ | async)?.type === "0" || (station$ | async)?.type === "2") {
            <p class="station__content__title --h2" [innerHTML]="'STATION_PAGE.PRECIPITATION' | translate"></p>

            <!-- Hack to allow for straight top borders without touching the app-chart component -->
            <div [class.empty-chart-placeholder]="emptyPrecipitationData$ | async">
                @if (!(emptyPrecipitationData$ | async)) {
                    <app-manager-chart>
                        @if (hasPrecipitation10Data$ | async) {
                            <app-chart-tab [title]="'STATION_PAGE.TEN_MINUTAL' | translate">
                                <app-precipitation-chart
                                    [data]="stationPrecipitation10Data$ | async"
                                    [precipitationLast1h]="
                                        'PRECIPITATION_UNIT'
                                            | translate
                                                : {
                                                      value:
                                                          (station$ | async)?.precipitationLast1h
                                                          | number: '1.0-2' : translateService.defaultLang,
                                                  }
                                    "
                                    [precipitationLast24h]="
                                        'PRECIPITATION_UNIT'
                                            | translate
                                                : {
                                                      value:
                                                          (station$ | async)?.precipitationLast24h
                                                          | number: '1.0-2' : translateService.defaultLang,
                                                  }
                                    "
                                ></app-precipitation-chart>
                            </app-chart-tab>
                        }
                        @if (hasPrecipitation60Data$ | async) {
                            <app-chart-tab [title]="'STATION_PAGE.HOURLY' | translate">
                                <app-precipitation-chart
                                    [data]="stationPrecipitation60Data$ | async"
                                    [precipitationLast1h]="
                                        'PRECIPITATION_UNIT'
                                            | translate
                                                : {
                                                      value:
                                                          (station$ | async)?.precipitationLast1h
                                                          | number: '1.0-2' : translateService.defaultLang,
                                                  }
                                    "
                                    [precipitationLast24h]="
                                        'PRECIPITATION_UNIT'
                                            | translate
                                                : {
                                                      value:
                                                          (station$ | async)?.precipitationLast24h
                                                          | number: '1.0-2' : translateService.defaultLang,
                                                  }
                                    "
                                ></app-precipitation-chart>
                            </app-chart-tab>
                        }
                    </app-manager-chart>
                } @else {
                    <app-empty-data [display]="true" [text]="'SENSOR_NO_DATA' | translate"></app-empty-data>
                }
            </div>

            <!-- If there's wind data show graph for wind. If not, don't.-->
            @if (hasWindData$ | async) {
                @if (hasWindGustData$ | async) {
                    <p class="station__content__title --h2" [innerHTML]="'STATION_PAGE.WIND_GUST' | translate"></p>
                } @else {
                    <p class="station__content__title --h2" [innerHTML]="'STATION_PAGE.WIND' | translate"></p>
                }
                <div class="station__content__card">
                    <app-empty-data [display]="!(emptyWindData$ | async)" [text]="'SENSOR_NO_DATA' | translate"></app-empty-data>
                    <ion-card class="station__content__card__summary border__bottom">
                        <img src="assets/images/wind.png" />
                        <div class="station__content__card__summary__values">
                            <div class="station__content__card__summary__value">
                                @if (hasWindGustData$ | async) {
                                    <p
                                        class="station__content__card__summary__title --h1"
                                        [innerHTML]="
                                            'WIND_UNIT'
                                                | translate: { value: windGust$ | async | number: '1.0-2' : translateService.defaultLang }
                                        "
                                    ></p>
                                } @else {
                                    <p
                                        class="station__content__card__summary__title --h1"
                                        [innerHTML]="
                                            'WIND_UNIT'
                                                | translate: { value: wind$ | async | number: '1.0-2' : translateService.defaultLang }
                                        "
                                    ></p>
                                }
                                <p
                                    class="station__content__card__summary__subtitle --h3"
                                    [innerHTML]="'STATION_PAGE.LAST_READING' | translate"
                                ></p>
                            </div>
                            <div class="station__content__card__summary__value" style="padding-left: calc(var(--space) * 2)">
                                @if (hasWindGustData$ | async) {
                                    @if (hasWindDirectionData$ | async) {
                                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start">
                                            <img
                                                *ngIf="(windGust$ | async) < WIND_SPEED_LEVELS.WIND_CALM"
                                                src="assets/images/windDir_0.png"
                                                [class]="'no__margin__icon'"
                                            />
                                            <img
                                                *ngIf="
                                                    (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_CALM &&
                                                    (windGust$ | async) < WIND_SPEED_LEVELS.WIND_WEAK
                                                "
                                                src="assets/images/windDir_1.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="
                                                    (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                                    (windGust$ | async) < WIND_SPEED_LEVELS.WIND_MODERATED
                                                "
                                                src="assets/images/windDir_2.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="
                                                    (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                                    (windGust$ | async) < WIND_SPEED_LEVELS.WIND_STRONG
                                                "
                                                src="assets/images/windDir_3.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="(windGust$ | async) >= WIND_SPEED_LEVELS.WIND_STRONG"
                                                src="assets/images/windDir_4.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <p
                                                class="station__content__card__summary__title --h1"
                                                [innerHTML]="windDirection$ | async | windDirectionName"
                                            ></p>
                                        </div>
                                    }
                                    <p
                                        *ngIf="(windGust$ | async) < WIND_SPEED_LEVELS.WIND_CALM"
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_CALM' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_CALM &&
                                            (windGust$ | async) < WIND_SPEED_LEVELS.WIND_WEAK
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_WEAK' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                            (windGust$ | async) < WIND_SPEED_LEVELS.WIND_MODERATED
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_MODERATED' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (windGust$ | async) >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                            (windGust$ | async) < WIND_SPEED_LEVELS.WIND_STRONG
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_STRONG' | translate"
                                    ></p>
                                    <p
                                        *ngIf="(windGust$ | async) >= WIND_SPEED_LEVELS.WIND_STRONG"
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_VERY_STRONG' | translate"
                                    ></p>
                                } @else {
                                    @if (hasWindDirectionData$ | async) {
                                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start">
                                            <img
                                                *ngIf="(wind$ | async) < WIND_SPEED_LEVELS.WIND_CALM"
                                                src="assets/images/windDir_0.png"
                                                [class]="'no__margin__icon'"
                                            />
                                            <img
                                                *ngIf="
                                                    (wind$ | async) >= WIND_SPEED_LEVELS.WIND_CALM &&
                                                    (wind$ | async) < WIND_SPEED_LEVELS.WIND_WEAK
                                                "
                                                src="assets/images/windDir_1.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="
                                                    (wind$ | async) >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                                    (wind$ | async) < WIND_SPEED_LEVELS.WIND_MODERATED
                                                "
                                                src="assets/images/windDir_2.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="
                                                    (wind$ | async) >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                                    (wind$ | async) < WIND_SPEED_LEVELS.WIND_STRONG
                                                "
                                                src="assets/images/windDir_3.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <img
                                                *ngIf="(wind$ | async) >= WIND_SPEED_LEVELS.WIND_STRONG"
                                                src="assets/images/windDir_4.png"
                                                [class]="'no__margin__icon rotate-' + (windDirection$ | async)"
                                            />
                                            <p
                                                class="station__content__card__summary__title --h1"
                                                [innerHTML]="windDirection$ | async | windDirectionName"
                                            ></p>
                                        </div>
                                    }
                                    <p
                                        *ngIf="(wind$ | async) < WIND_SPEED_LEVELS.WIND_CALM"
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_CALM' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (wind$ | async) >= WIND_SPEED_LEVELS.WIND_CALM && (wind$ | async) < WIND_SPEED_LEVELS.WIND_WEAK
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_WEAK' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (wind$ | async) >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                            (wind$ | async) < WIND_SPEED_LEVELS.WIND_MODERATED
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_MODERATED' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            (wind$ | async) >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                            (wind$ | async) < WIND_SPEED_LEVELS.WIND_STRONG
                                        "
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_STRONG' | translate"
                                    ></p>
                                    <p
                                        *ngIf="(wind$ | async) >= WIND_SPEED_LEVELS.WIND_STRONG"
                                        class="station__content__card__summary__subtitle --h3"
                                        [innerHTML]="'STATION_PAGE.WIND_VERY_STRONG' | translate"
                                    ></p>
                                }
                            </div>
                        </div>
                    </ion-card>
                    <ion-card class="station__content__card__hours">
                        @if (hasWindGustData$ | async) {
                            @for (windGustHour of windGustHours$ | async; track $index) {
                                <div class="station__content__card__hours__item">
                                    <p class="--small" [innerHTML]="windGustHour.timestamp"></p>
                                    @if (windDirectionHours$ | async) {
                                        <img
                                            *ngIf="windGustHour.value < WIND_SPEED_LEVELS.WIND_CALM"
                                            src="assets/images/windDir_0.png"
                                            [class]="'wind-img'"
                                        />
                                        <img
                                            *ngIf="
                                                windGustHour.value >= WIND_SPEED_LEVELS.WIND_CALM &&
                                                windGustHour.value < WIND_SPEED_LEVELS.WIND_WEAK
                                            "
                                            src="assets/images/windDir_1.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="
                                                windGustHour.value >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                                windGustHour.value < WIND_SPEED_LEVELS.WIND_MODERATED
                                            "
                                            src="assets/images/windDir_2.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="
                                                windGustHour.value >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                                windGustHour.value < WIND_SPEED_LEVELS.WIND_STRONG
                                            "
                                            src="assets/images/windDir_3.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="windGustHour.value >= WIND_SPEED_LEVELS.WIND_STRONG"
                                            src="assets/images/windDir_4.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <p
                                            class="--small"
                                            [innerHTML]="(windDirectionHours$ | async)[$index]?.value | windDirectionName"
                                        ></p>
                                    }
                                    <p
                                        class="--small --bold"
                                        [innerHTML]="
                                            'WIND_UNIT'
                                                | translate: { value: windGustHour.value | number: '1.0-2' : translateService.defaultLang }
                                        "
                                    ></p>
                                    <p
                                        *ngIf="windGustHour.value < WIND_SPEED_LEVELS.WIND_CALM"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_CALM' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            windGustHour.value >= WIND_SPEED_LEVELS.WIND_CALM &&
                                            windGustHour.value < WIND_SPEED_LEVELS.WIND_WEAK
                                        "
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_WEAK' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            windGustHour.value >= WIND_SPEED_LEVELS.WIND_WEAK &&
                                            windGustHour.value < WIND_SPEED_LEVELS.WIND_MODERATED
                                        "
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_MODERATED' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            windGustHour.value >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                            windGustHour.value < WIND_SPEED_LEVELS.WIND_STRONG
                                        "
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_STRONG' | translate"
                                    ></p>
                                    <p
                                        *ngIf="windGustHour.value >= WIND_SPEED_LEVELS.WIND_STRONG"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_VERY_STRONG' | translate"
                                    ></p>
                                </div>
                            }
                        } @else if (hasWindData$ | async) {
                            @for (value of windHours$ | async; track $index) {
                                <div class="station__content__card__hours__item">
                                    <p class="--small" [innerHTML]="value.timestamp"></p>
                                    @if (windDirectionHours$ | async) {
                                        <img
                                            *ngIf="value.value < WIND_SPEED_LEVELS.WIND_CALM"
                                            src="assets/images/windDir_0.png"
                                            [class]="'wind-img'"
                                        />
                                        <img
                                            *ngIf="value.value >= WIND_SPEED_LEVELS.WIND_CALM && value.value < WIND_SPEED_LEVELS.WIND_WEAK"
                                            src="assets/images/windDir_1.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="
                                                value.value >= WIND_SPEED_LEVELS.WIND_WEAK && value.value < WIND_SPEED_LEVELS.WIND_MODERATED
                                            "
                                            src="assets/images/windDir_2.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="
                                                value.value >= WIND_SPEED_LEVELS.WIND_MODERATED &&
                                                value.value < WIND_SPEED_LEVELS.WIND_STRONG
                                            "
                                            src="assets/images/windDir_3.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <img
                                            *ngIf="value.value >= WIND_SPEED_LEVELS.WIND_STRONG"
                                            src="assets/images/windDir_4.png"
                                            [class]="'wind-img rotate-' + (windDirectionHours$ | async)[$index]?.value"
                                        />
                                        <p
                                            class="--small"
                                            [innerHTML]="(windDirectionHours$ | async)[$index]?.value | windDirectionName"
                                        ></p>
                                    }
                                    <p
                                        class="--small --bold"
                                        [innerHTML]="
                                            'WIND_UNIT' | translate: { value: value.value | number: '1.0-2' : translateService.defaultLang }
                                        "
                                    ></p>
                                    <p
                                        *ngIf="value.value < WIND_SPEED_LEVELS.WIND_CALM"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_CALM' | translate"
                                    ></p>
                                    <p
                                        *ngIf="value.value >= WIND_SPEED_LEVELS.WIND_CALM && value.value < WIND_SPEED_LEVELS.WIND_WEAK"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_WEAK' | translate"
                                    ></p>
                                    <p
                                        *ngIf="value.value >= WIND_SPEED_LEVELS.WIND_WEAK && value.value < WIND_SPEED_LEVELS.WIND_MODERATED"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_MODERATED' | translate"
                                    ></p>
                                    <p
                                        *ngIf="
                                            value.value >= WIND_SPEED_LEVELS.WIND_MODERATED && value.value < WIND_SPEED_LEVELS.WIND_STRONG
                                        "
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_STRONG' | translate"
                                    ></p>
                                    <p
                                        *ngIf="value.value >= WIND_SPEED_LEVELS.WIND_STRONG"
                                        class="--small"
                                        [innerHTML]="'STATION_PAGE.WIND_VERY_STRONG' | translate"
                                    ></p>
                                </div>
                            }
                        }
                    </ion-card>
                    <div class="--straight__border__top">
                        @if (hasWindGustData$ | async) {
                            <app-wind-chart
                                [data]="(stationData$ | async)?.wind"
                                [windGustData]="(stationData$ | async)?.windGust"
                                [windSpeedAlertLevels]="windSpeedAlertLevels"
                            ></app-wind-chart>
                        } @else {
                            <app-wind-chart
                                [data]="(stationData$ | async)?.wind"
                                [windSpeedAlertLevels]="windSpeedAlertLevels"
                            ></app-wind-chart>
                        }
                    </div>
                </div>
            }
            @if (emptyThermalSensationData$ | async) {
                <p class="station__content__title --h2" [innerHTML]="'STATION_PAGE.TEMPERATURE_TITLE' | translate"></p>
                <app-manager-chart>
                    @if (hasTemperatureData$ | async) {
                        <app-chart-tab [title]="'STATION_PAGE.TEMPERATURE' | translate">
                            <!-- If there's temeprature data show station__content__card for temperature. If not, don't.-->

                            <div class="station__content__card">
                                <ion-card class="station__content__card__summary border__bottom">
                                    <img src="assets/images/temperature.png" />
                                    <div>
                                        <p
                                            class="station__content__card__summary__title --h1"
                                            [innerHTML]="
                                                'TEMPERATURE_UNIT'
                                                    | translate
                                                        : { value: temperature$ | async | number: '1.0-2' : translateService.defaultLang }
                                            "
                                        ></p>
                                        <p
                                            class="station__content__card__summary__subtitle --h3"
                                            [innerHTML]="'STATION_PAGE.LAST_READING' | translate"
                                        ></p>
                                    </div>
                                </ion-card>

                                @if (hasAirHumidityData$ | async) {
                                    <app-temperature-chart
                                        [data]="(stationData$ | async)?.temperature"
                                        [humidityData]="(stationData$ | async)?.airHumidity"
                                    ></app-temperature-chart>
                                } @else {
                                    <app-temperature-chart [data]="(stationData$ | async)?.temperature"></app-temperature-chart>
                                }
                            </div>
                        </app-chart-tab>
                    }

                    @if (hasThermalSensationData$ | async) {
                        <app-chart-tab [title]="'STATION_PAGE.THERMAL_SENSATION' | translate">
                            <!-- If there's temeprature data show station__content__card for temperature. If not, don't.-->

                            <div class="station__content__card">
                                <ion-card
                                    class="station__content__card__summary border__bottom"
                                    style="display: flex; justify-content: space-between; align-items: center"
                                >
                                    <img src="assets/images/temperature.png" />
                                    <div>
                                        <p
                                            class="station__content__card__summary__title --h1"
                                            [innerHTML]="
                                                'TEMPERATURE_UNIT'
                                                    | translate
                                                        : {
                                                              value:
                                                                  thermalSensation$
                                                                  | async
                                                                  | number: '1.0-2' : translateService.defaultLang,
                                                          }
                                            "
                                        ></p>
                                        <p
                                            class="station__content__card__summary__subtitle --h3"
                                            [innerHTML]="'STATION_PAGE.LAST_READING' | translate"
                                        ></p>
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 8px; margin-left: auto">
                                        <ion-button class="info-button" fill="clear" id="popover-trigger-thermal-sensation">
                                            <ion-icon name="information-circle-outline"></ion-icon>
                                        </ion-button>
                                        <ion-popover trigger="popover-trigger-thermal-sensation" triggerAction="click">
                                            <ng-template>
                                                <ion-content class="ion-padding modal-info">
                                                    {{ "THERMAL_SENSATION_INFO" | translate }}
                                                </ion-content>
                                            </ng-template>
                                        </ion-popover>
                                    </div>
                                </ion-card>

                                <app-thermal-sensation-chart
                                    [data]="(stationData$ | async)?.thermalSensation"
                                ></app-thermal-sensation-chart>
                            </div>
                        </app-chart-tab>
                    }
                </app-manager-chart>
            } @else {
                @if (hasTemperatureData$ | async) {
                    <div class="station__content__card">
                        <ion-card class="station__content__card__summary border__bottom">
                            <img src="assets/images/temperature.png" />
                            <div>
                                <p
                                    class="station__content__card__summary__title --h1"
                                    [innerHTML]="
                                        'TEMPERATURE_UNIT'
                                            | translate: { value: temperature$ | async | number: '1.0-2' : translateService.defaultLang }
                                    "
                                ></p>
                                <p
                                    class="station__content__card__summary__subtitle --h3"
                                    [innerHTML]="'STATION_PAGE.LAST_READING' | translate"
                                ></p>
                            </div>
                        </ion-card>

                        @if (hasAirHumidityData$ | async) {
                            <app-temperature-chart
                                [data]="(stationData$ | async)?.temperature"
                                [humidityData]="(stationData$ | async)?.airHumidity"
                            ></app-temperature-chart>
                        } @else {
                            <app-temperature-chart [data]="(stationData$ | async)?.temperature"></app-temperature-chart>
                        }
                    </div>
                } @else {
                    <app-empty-data [display]="true" [text]="'SENSOR_NO_DATA' | translate"></app-empty-data>
                }
            }

            <!-- If there's humidity data show station__content__card for humidity. If not, don't.-->
            @if (hasHumidityData$ | async) {
                <p class="station__content__title --h2" [innerHTML]="'STATION_PAGE.HUMIDITY' | translate"></p>

                <div class="station__content__card">
                    <app-empty-data [display]="emptyHumidityData$ | async" [text]="'SENSOR_NO_DATA' | translate"></app-empty-data>
                    <ion-card class="station__content__card__summary border__bottom">
                        <img src="assets/images/humidity.png" />
                        <div>
                            <p
                                class="station__content__card__summary__title --h1"
                                [innerHTML]="
                                    'HUMIDITY_UNIT'
                                        | translate: { value: humidity$ | async | number: '1.0-2' : translateService.defaultLang }
                                "
                            ></p>
                            <p
                                class="station__content__card__summary__subtitle --h3"
                                [innerHTML]="'STATION_PAGE.LAST_READING' | translate"
                            ></p>
                        </div>
                    </ion-card>

                    <ion-card class="station__content__card__hours">
                        @for (value of humidityHours$ | async; track value.timestamp) {
                            <div class="station__content__card__hours__item">
                                <p class="--small" [innerHTML]="value.timestamp"></p>
                                <img src="assets/images/humidity.png" />
                                <p
                                    class="--small"
                                    [innerHTML]="
                                        'HUMIDITY_UNIT' | translate: { value: value.value | number: '1.0-2' : translateService.defaultLang }
                                    "
                                ></p>
                            </div>
                        }
                    </ion-card>
                    <app-humidity-chart [data]="(stationData$ | async)?.humidity"></app-humidity-chart>
                </div>
            }
        }
    </div>
</ion-content>
